export default {
    methods: {
        handleNotification(value) {
            const rest = value.rest_api.toLowerCase();

            let id = value.id_manifest;
            if (rest === "cuti") {
                this.$router
                    .push({ name: "manifestCuti", params: { id: id } })
                    .catch(console.log());
            }else if (rest === "alokasi") {
              if(value.sebagai == 'Approval'){
                this.$router
                  .push({ name: "manifest.alokasi", params: { id: id } })
                  .catch(console.log());
              }else if(value.sebagai == 'User'){
                this.$router
                  .push({ name: "edit.alokasi", params: { id: id } })
                  .catch(console.log());
              }else if (value.deskripsi == 'Approved'){
                this.$router
                .push({ name: "manifest.alokasi", params: { id: id } })
                .catch(console.log());
              }
            } else if (rest === "spl") {
              this.$router
                .push({ name: "manifestSpl", params: { id: id } })
                .catch(console.log());
            } else if (rest === "realisasi_spl") {
              this.$router
                .push({ name: "manifestRealisasiSpl", params: { id: id } })
                .catch(console.log());
            }else if (rest === "klaim_kesehatan") {
              this.$router
                .push({ name: "manifestKlaim", params: { id: id } })
                .catch(console.log());
            }else if (rest === "rekap_tarif_lembur") {
              this.$router
                .push({ name: "manifest_rekap_realisasi_lembur", params: { id: id } })
                .catch(console.log());
            } else {
                this.$notification.error({
                    message: "Error",
                    description: "Dokumen tidak ditemukan, mohon hubungi administrator!"
                });
            }

            Event.$emit("notificationToggle"); // close notif
        }
    }
}
